import { grey } from "@ant-design/colors"
import { faSignalBars } from "@fortawesome/pro-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"

const SplashPage = () => {
  return <div style={{
    display: 'flex',
    flexDirection: 'column',
    gap: '24px',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100vh',
    width: '100%',
    color: grey[2],
  }}>
    <FontAwesomeIcon icon={faSignalBars} size="6x" />
    <h1 style={{ fontFamily: 'Proza Libre, sans-serif' }}>Select a System Setup Section</h1>
  </div>
}

export default SplashPage
